var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-collapse-transition',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],attrs:{"id":_vm.rowId}},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }